import api from './ApiService';

export async function getFaq(): Promise<any> {
  try {
    const response = await api.get('/faq');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar o faq', error);
    throw new Error('Erro ao carregar o faq');
  }
}
